import { render, staticRenderFns } from "./Decoration5.vue?vue&type=template&id=4e543c1d&scoped=true"
import script from "./Decoration5.vue?vue&type=script&lang=js"
export * from "./Decoration5.vue?vue&type=script&lang=js"
import style0 from "./Decoration5.vue?vue&type=style&index=0&id=4e543c1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e543c1d",
  null
  
)

export default component.exports